import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetRegionCoverage from './GetRegionCoverage'
import { $regionCoverageQuery } from '../stores'

export default createAction('DeleteRegion', async (regionId, supplierCode) => {
    const data = await FetchMappingCoverage({
        method: 'DELETE',
        path: `/region/${encodeURIComponent(regionId)}`,
        params: { supplier_code: supplierCode || undefined }
    })
    const scope = supplierCode ? ` (${supplierCode} rows only)` : ''
    notifyWrite(`Region ${regionId}: ${data.deleted || 0} row(s) deleted${scope}`, data)
    const query = $regionCoverageQuery.getState()
    if (query) {
        await GetRegionCoverage({ ...query, page: 1 })
    }
    return data
})
